import type { Point2d, SimpleMesh2d } from ".."
import type { Edge2d, ExtractMeshOptions } from "../../mesh"

export const packMesh = (mesh: Readonly<SimpleMesh2d>): ExtractMeshOptions => ({
  nodeIds: Object.keys(mesh.nodes),
  edgeIds: Object.keys(mesh.edges),
  getNode: (id: string): Point2d => mesh.nodes[id],
  getEdge: (id: string): Edge2d => mesh.edges[id],
})
